// Udyan 29 Sep: "Be a VIP" newsletter form. Submits without reloading the page, shows a spinner inside the button while
// it works, then swaps the form for the welcome code. Markup: sections/newsletter.liquid.
// If Shopify asks for a captcha (bot protection), falls back to a normal submit so the shopper can complete it.
(function () {
  function init(form) {
    if (form.dataset.utBound) return;
    form.dataset.utBound = '1';
    var wrap = form.closest('.newsletter-form') || form.parentElement;
    var success = wrap.querySelector('[data-ut-nl-success]');
    var button = form.querySelector('button[type="submit"]');
    var input = form.querySelector('input[type="email"]');

    function setLoading(on) {
      form.classList.toggle('ut-nl--loading', on);
      if (button) {
        button.disabled = on;
        button.setAttribute('aria-busy', String(on));
      }
    }

    function showError(message) {
      var box = form.querySelector('.ut-nl-error');
      if (!box) {
        box = document.createElement('small');
        box.className = 'ut-nl-error form__message';
        box.setAttribute('role', 'alert');
        (form.querySelector('.newsletter-form__field-wrapper') || form).appendChild(box);
      }
      box.textContent = message;
      if (input) input.setAttribute('aria-invalid', 'true');
    }

    function showSuccess() {
      form.hidden = true;
      var inner = form.closest('.newsletter__inner');
      if (inner) inner.classList.add('ut-nl-done');
      if (success) {
        success.hidden = false;
        success.focus({ preventScroll: true });
        success.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }

    // Anything we can't read in the background (spam check / captcha, a redirect to another address, a network
    // hiccup): hand over to a normal submit. Shopify then returns to this section (#ut-newsletter) and the page
    // shows the welcome code itself.
    function submitNormally() {
      HTMLFormElement.prototype.submit.call(form);
    }

    form.addEventListener('submit', function (event) {
      if (!window.fetch || !window.FormData) return; // old browsers: normal submit
      event.preventDefault();
      if (input && !input.checkValidity()) {
        input.reportValidity();
        return;
      }
      var old = form.querySelector('.ut-nl-error');
      if (old) old.remove();
      setLoading(true);

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
        credentials: 'same-origin',
      })
        .then(function (response) {
          return response.text().then(function (html) {
            return { url: response.url || '', html: html };
          });
        })
        .then(function (res) {
          if (res.url.indexOf('/challenge') !== -1 || /h-captcha|hcaptcha|challenge/i.test(res.html.slice(0, 20000)) && res.url.indexOf('customer_posted') === -1) {
            submitNormally();
            return;
          }
          var doc = new DOMParser().parseFromString(res.html, 'text/html');
          var ok = res.url.indexOf('customer_posted=true') !== -1 || doc.querySelector('.newsletter-form__message--success');
          if (ok) {
            setLoading(false);
            showSuccess();
            return;
          }
          var err = doc.querySelector('[id^="Newsletter-error--"]');
          if (err) {
            setLoading(false);
            showError(err.textContent.trim());
            return;
          }
          submitNormally();
        })
        .catch(function () {
          submitNormally();
        });
    });
  }

  function initCopy(root) {
    root.querySelectorAll('[data-ut-nl-copy]').forEach(function (btn) {
      if (btn.dataset.utBound) return;
      btn.dataset.utBound = '1';
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-ut-nl-copy');
        var done = function () {
          btn.textContent = 'Copied';
          setTimeout(function () {
            btn.textContent = 'Copy';
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('form[data-ut-newsletter]').forEach(init);
    initCopy(document);
    // Back from a normal submit: bring the welcome code into view.
    if (/[?&]customer_posted=true/.test(window.location.search)) {
      var panel = document.querySelector('[data-ut-nl-success]:not([hidden])');
      if (panel) {
        var inner = panel.closest('.newsletter__inner');
        if (inner) inner.classList.add('ut-nl-done');
        setTimeout(function () {
          panel.scrollIntoView({ block: 'center' });
        }, 100);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
